<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import {Modal, ModalBody, ModalHeader, Button, ModalFooter, Table, ButtonGroup, CustomInput} from 'sveltestrap';
    import { selectedGroup } from '../store';
    import Expander from '../components/Expander.svelte';
    import Search from '../components/Search.svelte';
    import http from '../api/http';
    import Validator from '../Helpers/Validator';
    import '../css/app.css'
	import { each } from 'svelte/internal';

    const dispatch = createEventDispatcher();

    const createMode = 'create';
    const deleteMode = 'delete';
    const editMode = 'edit';
    const removeMode = 'remove';
    const computerAttributesUpdated = 'computerAttributesUpdated';

    let shown = false;
    let errorMessage = "";
    let attributeName = "";
    let attributeValue = "";
    let deleteAttributes = false;
    let removeAttributes = false;
    let computers = [];
    let mode = createMode;
    let computerAttributes = [];
    let addedAttributes = [];
    let searchTerm
    let nameSearchResults = [];
    let selectedAttributes = [];
    let computersWithAttributesToRemove = [];
    let modeText = 'Create Attributes';
    let additionalComputers = [];
    let successMessage = "";
    let labelText = "No"
    let addAdditionalComputers = false;
    let pageSearchTerm = "";
    let attributeToEdit;

    function toggleAddAdditionalComputers(){
        if(addAdditionalComputers){
            addAdditionalComputers = false;
            labelText = "No";
        }
        else{
            addAdditionalComputers = true;
            labelText = "Yes";
        }
    }

    async function setMode(switchMode) {
        selectedAttributes = [];
        selectedAttributes = selectedAttributes;
        successMessage = "";
        errorMessage = "";
       if(switchMode == createMode){
          modeText = 'Create Attributes';
          mode = createMode;
       }
       else if(switchMode == deleteMode){
            modeText = 'Delete Attributes';
            mode = deleteMode;
            await GetComputerAttributes();
        }
        else if(switchMode == editMode){
            modeText = 'Edit Attributes';
            mode = editMode;
            await GetComputerAttributes();
        }
         else if(switchMode == removeMode){
            modeText = 'Remove Attributes From Computer(s)'
            mode = removeMode;
       }
    }

    async function toggle() {
        if(shown){
            computers = [];
            shown = false;
            resetModal();
        }
        else{
            shown = true;
            await GetComputerAttributes();
        }
    }

    function resetModal(){
        computers = [];
        addedAttributes = [];
        selectedAttributes.forEach(attribute => {
            attribute.selected = false;
        });
        selectedAttributes = [];
        computersWithAttributesToRemove = [];
        searchTerm = "";
        errorMessage = "";
        deleteAttributes = false;
        removeAttributes = false;
        mode = createMode;
        modeText = 'Create Attributes';
        selectedAttributes = selectedAttributes;
        addedAttributes = addedAttributes;
        computers = computers;
        pageSearchTerm = "";
        successMessage = "";
        addAdditionalComputers = false;
        additionalComputers = [];
    }

    async function GetComputerAttributes() {
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/true/${$selectedGroup}`);
        computerAttributes = await res.json();
    }

    async function validateDelete() {
        if(selectedAttributes.length > 0){
            deleteAttributes = true;
        }
        else{
            errorMessage = "Please select at least one attribute to delete.";
        }
    }

    async function validateRemove() {
        if(selectedAttributes.length > 0){
            removeAttributes = true;
        }
        else{
            errorMessage = "Please select at least one attribute to remove from the computers.";
        }
    }

    async function deleteComputerAttributes() {
        const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/${$selectedGroup}`, selectedAttributes);
        if(res.status == 200){
            toggle();
            dispatch(computerAttributesUpdated);
            deleteAttributes = false;
            selectedAttributes.forEach(attribute => {
                attribute.selected = false;
            });
            selectedAttributes = [];
            selectedAttributes = selectedAttributes;
        }
        else{
            errorMessage = "There was an error deleting the attributes.";
        }
    }

    async function removeComputerAttributeLinks() {
        let computersAndAttributes = {
            computers: computersWithAttributesToRemove,
            attributes: selectedAttributes
        }
        const res = await http.delete(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/link/${$selectedGroup}`, computersAndAttributes);
        if(res.status == 200){
            toggle();
            dispatch(computerAttributesUpdated);
            selectedAttributes.forEach(attribute => {
                attribute.selected = false;
            });
            deleteAttributes = false;
            selectedAttributes = [];
            selectedAttributes = selectedAttributes;
        }
        else{
            errorMessage = "There was an error removing attributes from the computers.";
        }
    }

    async function editAttribute(attribute) {
        const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/${$selectedGroup}`, attribute);
        if(res.status == 200)
        {
            dispatch(computerAttributesUpdated);
            GetComputerAttributes();
            computerAttributes = computerAttributes;
            successMessage = `Attribute '${attribute.name} | ${attribute.value}' successfully updated.`
        }
        else{
            errorMessage = "There was an error editing the attributes.";
        }
    }

    async function getAdditionalComputers(){
        var selectedComputerIds = "";
        computers.forEach(computer => {
                selectedComputerIds += computer.id.toString() + ",";
            });  
        selectedComputerIds = selectedComputerIds.slice(0, -1);
        const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/computers/minusselected/${selectedComputerIds}/${pageSearchTerm}/${$selectedGroup}`);
        if(res.status == 200){
            additionalComputers = await res.json();
        }
        else{
            errorMessage = "There was an error getting the computers.";
        }
    }

    
    function validateAttributeField(fieldName, fieldValue){
        if(fieldValue.length > 100){
            errorMessage = `${fieldName} cannot be longer than 100 characters.`;
        }
        else if(Validator.regex(fieldValue,'[<>\+\-\.=%:]')){
            errorMessage = `${fieldName} cannot contain the following characters <>+-.=%:`;
        }
        else{
            errorMessage = "";
        }
    }

    export async function show(selectedComputers, search) {
        computers = selectedComputers;
        shown = true;
        pageSearchTerm = search;
        if(pageSearchTerm != "" && selectedComputers.length > 0){
            await getAdditionalComputers();
        }
    }

    function createAttribute() {
        attributeName = searchTerm;
        let theAttribute ={
            name: attributeName,
            value: attributeValue
        }
        addedAttributes.push(theAttribute);
        addedAttributes = addedAttributes;
        attributeName = "";
        attributeValue = "";
    }

    function removeComputerAttribute(attribute) {
        addedAttributes = addedAttributes.filter(item => item !== attribute);
    }

    function selectAttribute(attribute, computer) {
        let index = computersWithAttributesToRemove.findIndex(c => c.id === computer.id);
        if(index === -1 && mode != deleteMode){
            computersWithAttributesToRemove.push(computer);
        }
        if(selectedAttributes.includes(attribute)){
            attribute.selected = false;
            selectedAttributes = selectedAttributes.filter(item => item !== attribute);
            selectedAttributes = selectedAttributes;
        }
        else{
            attribute.selected = true;
            selectedAttributes.push(attribute);
            selectedAttributes = selectedAttributes;
        }
    }

    async function searchAttributeNames() {
        let searchResults  = document.getElementsByClassName("search-results")[0];
        if(searchTerm.length > 0){
            searchResults.style.display = "block";
            const res = await http.get(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/search/name/${searchTerm.toLocaleLowerCase()}/${$selectedGroup}`);
            nameSearchResults = await res.json(); 
            validateAttributeField("Attribute Name", searchTerm);
        }
        else{
            searchResults.style.display = "none";
        }
    }

    async function resetSearch() {
        let searchResults = document.getElementsByClassName("search-results")[0];
        if(searchResults.style.display = "block"){
            searchResults.style.display = "none";
        }
    }

    async function setSearchTerm(string) {
        searchTerm = string;
        let searchResults = document.getElementsByClassName("search-results")[0];
        searchResults.style.display = "none";
        searchTerm = searchTerm;
    }

    async function confirmClicked() {
        if(addAdditionalComputers){
            computers = computers.concat(additionalComputers);
        }
        computers.forEach(computer => {
            computer.attributes.push(...addedAttributes);
        });
        if(addedAttributes.length > 0){
            let res;
            if(computers.length > 0)
            {
                res = await http.post(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/${$selectedGroup}`, computers);
            }
            else
            {
                res = await http.post(window.apiBaseUrl + `/deploy/dashboard/attribute/computer/attributeonly/${$selectedGroup}`, addedAttributes);
            }
            if(res.status == 200){
                toggle();
                dispatch(computerAttributesUpdated);
                await GetComputerAttributes();
            }
            else{
                errorMessage = "There was an error adding the attributes.";
            }
        }
        else{
            errorMessage = "You must add at least one attribute.";
        }
    }

    onMount(() => {
        GetComputerAttributes();
    });
</script>

<Modal size="xl" isOpen={shown} {toggle}>
    <ModalHeader {toggle}>
        Manage Attributes
    </ModalHeader>
    <ModalBody>
        <div class="container">
        <div class="d-flex m-2">
            <h3 class="modalHeading">{modeText}</h3>
            <ButtonGroup class="ml-auto">
                <Button id="manage-computer-attributes-create-button" color="primary" class="btnGrp" on:click={() => setMode(createMode)} active={mode == createMode}><i class="fa fa-plus"></i> Create</Button>
                <Button id="manage-computer-attributes-edit-button" color="primary" class="btnGrp" on:click={() => setMode(editMode)} active={mode == editMode}><i class="fa fa-edit"></i> Edit</Button>
                <Button id="manage-computer-attributes-remove-button" color="primary"  class="btnGrp" on:click={() => setMode(removeMode)} active={mode == removeMode}><i class="fa fa-minus"></i> Remove</Button>
                <Button id="manage-computer-attributes-delete-button" color="primary" class="btnGrp" on:click={() => setMode(deleteMode)} active={mode == deleteMode}><i class="fa fa-trash"></i> Delete</Button>
            </ButtonGroup>
         </div>
       
        {#if mode == createMode}
            <div class="container">
                 <div class="row">
                    <p class="col">Attribute Name</p>
                    <p class="col">Attribute Value</p>
                    <p class="col"></p>
                </div>
                <div class="row">
                    <div class="col form-group">
                        <Search id="manage-computer-attributes-name-search" bind:searchTerm type="text" placeholder="Attribute Name" on:input={()=> searchAttributeNames()} on:focusout={() => resetSearch()} />
                        <div class="search-results">
                            {#each nameSearchResults as result}
                                <div id="manage-computer-attributes-name-result-{result}" class="result" on:mousedown={() => setSearchTerm(result)}>
                                    <p>{result}</p>
                                </div>
                            {/each}
                        </div>
                        <small>Select an existing attribute name or create a new one.</small>
                    </div>
                    <div class="col form-group">
                        <input id="manage-computer-attributes-value-input" class="form-control" bind:value={attributeValue} on:input={() => validateAttributeField("Attribute Value", attributeValue )} type="text"  placeholder="Attribute Value"  />
                    </div>
                    <div class="col form-group">
                        <button id="manage-computer-attributes-create-button" on:click={() => createAttribute()} disabled={errorMessage != ""} class="btn btn-outline-primary">Add Attribute</button>
                     </div>
                </div> 
                {#each addedAttributes as attribute}
                    <div class="row">
                        <div class="col form-group">
                            <input class="form-control" bind:value={attribute.name} type="text" disabled/>
                        </div>
                        <div class="col form-group">
                            <input class="form-control" bind:value={attribute.value} type="text" disabled/>
                        </div>
                        <div class="col form-group">
                            <button id="manage-computer-attributes-remove-attribute-button-{attribute.name}:{attribute.value}" on:click={() => removeComputerAttribute(attribute)} class="btn btn-outline-danger">Remove Attribute</button>
                        </div>
                    </div> 
                {/each}
            </div>
            <h3 class="modalHeading">Currently Editing ({computers.length}) Computer(s)</h3>

            {#if computers.length > 0}
                <Expander expanderTitle="Show ({computers.length}) Computers">
                        {#each computers as computer}
                            <div class="row mt-1">
                                <div class="form-group col computer">
                                    <input class="form-control" type="text" bind:value={computer.hostName} disabled>
                                </div>
                            </div>
                        {/each}
                    </Expander>
                {:else}
                 <p class="text-warning">You are currently creating attributes with no computers selected. <br>If you wish to apply attributes to computers first ensure that you have selected the computers you wish to apply attributes to. </p>
            {/if}
            {#if additionalComputers.length > 0}
                <div class="d-flex">
                    <h5 class="modalHeading">({additionalComputers.length}) computers have been found matching search criteria, would you like to apply attributes to these computers?</h5>
                    <div class="ml-auto">
                        <CustomInput id="manage-computer-attributes-additional-vessels-switch" type="switch" on:change={() => toggleAddAdditionalComputers()} label={labelText}></CustomInput>
                    </div>
                </div>
                <Expander expanderTitle="Show ({additionalComputers.length}) Computers">
                    {#each additionalComputers as computer}
                        <div class="row">
                            <div class="form-group col computer">
                                <input class="form-control" type="text" bind:value={computer.hostName} disabled>
                            </div>
                        </div>
                    {/each}
                </Expander>
            {/if}
        {/if}

        {#if mode == editMode}
            {#if computerAttributes.length > 0}
            <p class="text-warning">Editing attributes here will affect all computers with those attributes attached to them.</p>
            <Table repsonsive>
                <thead>
                    <tr>
                        <th>Attribute Name</th>
                        <th>Attribute Value</th>
                    </tr>
                </thead>
                <tbody>
                    {#each computerAttributes as attribute}
                        <tr id="manage-computer-attributes-edit-row-{attribute.name}-{attribute.value}" class="pointer" on:mousedown={() => attributeToEdit = attribute}>
                            <td>{attribute.name}</td>
                            <td>{attribute.value}</td>
                        </tr>
                    {/each}
                </tbody>
                </Table>
                    {#if attributeToEdit != undefined}
                        <div class="row">
                            <p class="col">Attribute Name</p>
                            <p class="col">Attribute Value</p>
                            <p class="col"></p>
                        </div>
                        <div class="row">
                            <div class="col form-group">
                                <input id="manage-computer-attributes-edit-input-name-{attributeToEdit.name}" class="form-control" bind:value={attributeToEdit.name} type="text" on:input={() => validateAttributeField("Attribute Name", attributeToEdit.name )} />
                            </div>
                            <div class="col form-group">
                                <input id="manage-computer-attributes-edit-input-value-{attributeToEdit.value}" class="form-control" bind:value={attributeToEdit.value} type="text" on:input={() => validateAttributeField("Attribute Value", attributeToEdit.value )} />
                            </div>
                            <div class="col form-group">
                                <button id="manage-computer-attributes-edit-save-button" on:click={() => editAttribute(attributeToEdit)} disabled={errorMessage != ""} class="btn btn-outline-info">Save Changes</button>
                            </div>
                        </div> 
                    {/if}
                {:else}
                <p>There are currently no attributes to show.</p>
            {/if}
        {/if} 

        {#if mode == removeMode}
            {#if computers.length > 0}
                {#each computers as computer }
                    {#if computers.length > 1}
                        <Expander titleIcon="desktop" expanderTitle="View {computer.hostName} Attributes">
                            {#if computer.attributes.length > 0}
                                <Table>
                                    <thead>
                                        <th></th>
                                        <th>Attribute Name</th>
                                        <th>Attribute Value</th>
                                    </thead>
                                    <tbody>
                                        {#each computer.attributes as attribute}
                                            <tr>
                                                <td><input id="computer-attribute-{attribute.id}-checkbox" type="checkbox" checked={attribute.selected}  on:mousedown={() => selectAttribute(attribute, computer)}/></td>
                                                <td>{attribute.name}</td>
                                                <td>{attribute.value}</td>
                                            </tr>
                                        {/each}
                                    
                                    </tbody>
                                </Table>
                                {:else}
                                <p><strong class="text-info mt-2">{computer.name}</strong> has no attributes.</p>
                            {/if}
                        </Expander>
                        {:else}
                         {#if computer.attributes.length > 0}
                            <Table>
                                <thead>
                                    <th></th>
                                    <th>Attribute Name</th>
                                    <th>Attribute Value</th>
                                </thead>
                                <tbody>
                                    {#each computer.attributes as attribute}
                                        <tr>
                                            <td><input type="checkbox" checked={attribute.selected}  on:mousedown={() => selectAttribute(attribute, computer)}/></td>
                                            <td>{attribute.name}</td>
                                            <td>{attribute.value}</td>
                                        </tr>
                                    {/each}
                                  
                                </tbody>
                            </Table>
                            {:else}
                            <p><strong class="text-info mt-2">{computer.hostName}</strong> has no attributes.</p>
                         {/if}
                    {/if}
                {/each}
            
                {#if removeAttributes == true}
                    <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action will affect multiple computers, attributes of this name will be removed from selected computers. <br/> Are you sure you wish to proceed?</p>
                {/if}
                {:else}
                <p>There are currently no computers selected.<br/>To remove attributes, first ensure you have selected computers that you wish to remove attributes from.</p>
            {/if}
        {/if}

         {#if mode == deleteMode}
            {#if computerAttributes.length > 0}
            <p class="text-warning">Deleting attributes here will affect all computers with those attributes attached to them.</p>
                <Table repsonsive>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Attribute Name</th>
                            <th>Attribute Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each computerAttributes as attribute}
                            <tr>
                                <td><input id="computer-attribute-{attribute.id}-checkbox" type="checkbox" checked={attribute.selected}  on:mousedown={() => selectAttribute(attribute)}/></td>
                                <td>{attribute.name}</td>
                                <td>{attribute.value}</td>
                            </tr>
                        {/each}
                    </tbody>
                </Table>
                {#if deleteAttributes == true}
                    <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> This action will affect multiple computers, attributes of this name will be deleted and cannot be undone. <br/> Are you sure you wish to proceed?</p>
                {/if}
                {:else}
                <p>No attributes to show.</p>
            {/if}
        {/if}
        <p class="text-danger">{errorMessage}</p>
        <p class="text-success">{successMessage}</p>
        </div>
    </ModalBody>
    <ModalFooter>
        {#if mode == createMode}
            <button id="computer-attribute-create-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
            <button id="computer-attribute-create-confirm-button" class="btn btn-primary" on:click={() => confirmClicked()}>Confirm</button>
        {/if}
        {#if mode == editMode}
            <button id="computer-attribute-edit-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
            <button id="computer-attribute-edit-confirm-button" class="btn btn-primary" on:click={() => toggle()}>Done</button>
        {/if}
        {#if mode == deleteMode}
            {#if deleteAttributes == false}
                <button id="computer-attribute-delete-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
                <button id="computer-attribute-delete-validate-button" class="btn btn-danger" on:click={() => validateDelete()}>Delete Attributes</button>
                {:else}
                <button id="computer-attribute-delete-stop-button" class="btn btn-outline-primary" on:click={() => deleteAttributes = false}>Cancel</button>
                <button id="computer-attribute-delete-confirm-button" class="btn btn-danger" on:click={() => deleteComputerAttributes()}>Delete {selectedAttributes.length} Attributes</button>
            {/if}
        {/if}
        {#if mode == removeMode}
         {#if removeAttributes == false}
                <button id="computer-attribute-remove-cancel-button" class="btn btn-outline-primary" on:click={() => toggle()}>Cancel</button>
                <button id="computer-attribute-remove-validate-button" class="btn btn-danger" on:click={() => validateRemove()}>Remove Attributes</button>
                {:else}
                <button id="computer-attribute-remove-stop-button" class="btn btn-outline-primary" on:click={() => removeAttributes = false}>Cancel</button>
                <button id="computer-attribute-remove-confirm-button" class="btn btn-danger" on:click={() => removeComputerAttributeLinks()}>Remove {selectedAttributes.length} Attributes From Computer(s)</button>
            {/if}
        {/if}
    </ModalFooter>
</Modal>

<style>
    .computer input{
        border-color: transparent;
    }
</style>